import { Fab } from "@material-ui/core";
import { ClassNameMap } from "@material-ui/core/styles/withStyles";
import PrintIcon from '@material-ui/icons/Print';
import { useState } from "react";
import DataPanel from "../DataPanel";
import CustomerDetails from "./CustomerDetails";
import CustomerOfferDialog from "./CustomerOfferDialog";

const columns = [
  {
    name: 'name',
    label: 'Nazwa',
  }
];

const CustomersPanel = () => {
  const [isCustomerOfferDialogOpen, setCustomerOfferDialogOpen] = useState<boolean>(false);

  const renderPrintOfferButton = (
    buttonClasses: ClassNameMap,
    getSelectedIds: () => number[]
  ) => {
    const selectedCustomerIds = getSelectedIds();
    const selectedCustomerId = selectedCustomerIds[0];
    return <>
      <Fab
        aria-label="print"
        className={buttonClasses.button}
        color="primary"
        disabled={selectedCustomerIds.length !== 1}
        size="medium"
        onClick={() => setCustomerOfferDialogOpen(true)}
      >
        <PrintIcon/>
      </Fab>
      <CustomerOfferDialog
        customerId={selectedCustomerId}
        open={isCustomerOfferDialogOpen}
        onCancel={() => setCustomerOfferDialogOpen(false)}
      />
    </>
  };

  return (
    <DataPanel
      title='Klienci'
      resource='customers'
      columns={columns}
      renderDetails={(props) => <CustomerDetails { ...props } />}
      renderCustomButtons={renderPrintOfferButton}
      tableSearchEnabled
    />
  );
};
export default CustomersPanel;